import { ReactNode } from 'react';

type WrapIfProps = {
    condition: boolean;
    children: ReactNode;
    wrapper?: (children: ReactNode) => ReactNode;
};

const WrapIf = ({
    condition,
    children,
    wrapper,
}: WrapIfProps): JSX.Element | null => {
    if (!children) {
        return null;
    }

    if (!condition || !wrapper) {
        return children as JSX.Element;
    }

    // @ts-ignore
    return wrapper(children);
};

export default WrapIf;
